module.exports = __webpack_public_path__ + "static/media/menu-ship.5200edfe.png";